import { render, staticRenderFns } from "./MinisiteHeader.vue?vue&type=template&id=0347d13d&scoped=true&"
import script from "./MinisiteHeader.vue?vue&type=script&lang=js&"
export * from "./MinisiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteHeader.vue?vue&type=style&index=0&id=0347d13d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0347d13d",
  null
  
)

export default component.exports